import React, { useState } from 'react';
import { Button, Space, Input, Form, Select, Row, Col, Tag, Typography, notification } from 'antd';
import { PlusOutlined, SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { TableCustom } from '../../../components/TableCustom';
import { useMutation, useQuery } from '@tanstack/react-query';
import { deleteBlocksRequest, getListBlocksRequest } from '../../../services/onlinestore/blockServiceRequest';
import { Link, useHistory, useNavigate } from 'react-router-dom';
import { AppSelect } from '../../../constants/appSelect';
import { newObjectKeys } from '../../../utils/utility';
import { deleteTagRequest, getListTagsRequest } from '../../../services/onlinestore/tagServiceRequest';

const { Text } = Typography;

const QuanLyTag = () => {
  const navigate = useNavigate();
  const [formSearch] = Form.useForm();
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
  });

  const {
    data: dataTags,
    isPending,
    refetch: refetchDataBlocks,
  } = useQuery({ queryKey: ['dataTags', params], queryFn: () => getListTagsRequest(params) });

  const { mutate: mutateDeleteTag } = useMutation({
    mutationFn: deleteTagRequest,
    onSuccess: async (data) => {
      if (data?.status === 1) {
        notification.success({
          message: 'Xóa tag thành công!',
        });
        refetchDataBlocks();
      } else {
        notification.error({
          message: data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = (values) => {
    const temp = { page: 1, limit: params.limit };
    if (values?.title) {
      Object.assign(temp, { title: values?.title });
    }
    if (values?.status >= 0) {
      Object.assign(temp, { status: [values?.status] });
    }

    setParams(temp);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Tên tag',
      dataIndex: ['id', 'title'],
      key: 'id',
      render: (_, { title, id }) => (
        <Link to={`/online-store/quan-ly-tags/${id}/sua-tag`} className="text-[#1677FF]">
          {title}
        </Link>
      ),
    },
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      render: (icon) => (icon ? <img src={icon} alt="" className="w-10 h-auto object-contain" /> : ''),
    },
    {
      title: 'Thứ tự',
      dataIndex: 'order_place',
      key: 'order_place',
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag
          className="px-2 py-1 text-center"
          color={AppSelect.TAG_STATUS?.find((item) => item?.value === status)?.color}
        >
          {AppSelect.TAG_STATUS?.find((item) => item?.value === status)?.label}
        </Tag>
      ),
    },
    {
      title: 'Thời gian tạo',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (_, { created_at }) => (
        <Space>{created_at && <Text className="text-[#667085]">{created_at}</Text>}</Space>
      ),
    },
    {
      title: 'Cập nhật lần cuối',
      dataIndex: ['updated_by', 'updated_at'],
      key: 'updated_at',
      render: (_, { updated_by, updated_at }) => (
        <Space direction="vertical">
          {updated_by && <Text className="text-[#667085]">{updated_by}</Text>}
          {updated_at && <Text className="text-[#667085]">{updated_at}</Text>}
        </Space>
      ),
    },
    {
      title: 'Thao tác',
      key: 'action',
      render: (_, record) => (
        <Space size={0}>
          <Button type="text" onClick={() => navigate(`/online-store/quan-ly-tags/${record?.id}/sua-tag`)}>
            <EditOutlined />
          </Button>
          <Button type="text" onClick={() => mutateDeleteTag({ id: record?.id })}>
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="m-5">
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-2xl">Danh sách tags</h1>
        <Link to={'/online-store/quan-ly-tags/them-tag'}>
          <Button type="primary">
            <PlusOutlined />
            Thêm tag
          </Button>
        </Link>
      </div>

      <Form
        name="search_tags"
        form={formSearch}
        layout="vertical"
        requiredMark={false}
        className="mb-5"
        onFinish={handleSubmitForm}
      >
        <Row gutter={[16, 16]}>
          {/* First column: Partner name input */}
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="title" label={<Text>Tên khối</Text>}>
              <Input placeholder="Nhập tên tag" />
            </Form.Item>
          </Col>
          {/* Second column: Status dropdown */}
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="status" label={<Text>Trạng thái</Text>} initialValue={-1}>
              <Select
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={[{ value: -1, label: 'Tất cả' }, ...AppSelect.TAG_STATUS]}
              />
            </Form.Item>
          </Col>
          <Col className="flex items-center gap-2">
            <Button type="primary" htmlType="submit">
              <SearchOutlined />
              Tìm kiếm
            </Button>
            {params && Object.values(newObjectKeys(params, ['title', 'status'])).some((value) => value) && (
              <Button
                htmlType="button"
                onClick={() => {
                  formSearch.resetFields();
                  setParams({ page: 1, limit: params.limit });
                }}
              >
                <DeleteOutlined />
                Xóa lọc
              </Button>
            )}
          </Col>
        </Row>
      </Form>

      <TableCustom
        columns={columns}
        dataSource={dataTags?.data}
        totalItem={dataTags?.total}
        params={params}
        setParams={setParams}
      />
    </div>
  );
};

export default QuanLyTag;
